import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const TitleLgText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        testID="title-lg"
        style={[styles.titleLgText, style]}
        {...props}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  titleLgText: {
    ...theme.typography.title.lg,
    color: theme.color.text.primary,
  },
});

export default TitleLgText;
